import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';

import {
  CREATE_APPLICATION,
  DOWNLOAD_NOnIndividual_PDF,
  DOWNLOAD_PDF,
  DOWNLOAD_PDF_DIGIO,
  DOWNLOAD_PDF_AFTER_ESIGN,
  DOWNLOAD_MULTIPLEFILES,
  DOWNLOAD_PHYSICAL_SIGN_MULTIPLEFILES,
  APPLICATION_RECHECK,
  DELETE_APPLICATION,
  GET_TRANSFER_APPLICATIONS,
  UPLOAD_DIS_SLIP,
  DOWNLOAD_DIS_SLIP,
  APPROVE_DIS_SLIP,
  GET_PLEDGE_UNPLEDGE_APPLICATIONS,
  GET_ALL_PLEDGE_REQUEST,
  GET_PLEDGE_MIS,
} from '../../core/constants/api-endpoints';
import {
  ACCESS_TOKEN,
  AUTHORIZATION,
  BEARER_TOKEN_PREFIX,
} from '../../core/constants/app-strings';
import { Subject } from 'rxjs';
import { Application } from 'src/app/core/model/application.model';
import { share } from 'rxjs/operators';
@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  constructor(private http: HttpClient) { }

  private dataSource = new Subject<Application>();
  application = this.dataSource.asObservable().pipe(share());

  // getDashboard(body: ApplicationList) {
  //   const url = environment.APIURL + CREATE_APPLICATION;

  //   return this.http.get(url, { headers });
  // }
  // sortOrder, pageNumber = 0, pageSize = 10, query

  getApplicationList(options: {
    sortOrder?: any;
    pageNumber?: number;
    pageSize?: number;
    query?: string;
    type?: string;
    roleId?: string;
    istopup?: string;
    istransfer?: string;
    mode?: string;
  }) {
    const {
      sortOrder = { createdOn: 'DESC' },
      pageNumber = 0,
      pageSize = 10,
      query = '',
      type,
      roleId,
      istopup,
      istransfer,
      mode
    } = options || {};

    const params = new HttpParams()
      .set('limit', pageSize.toString())
      .set('start', pageNumber.toString())
      .set('offset', (pageNumber * pageSize).toString())
      .set('sort', JSON.stringify(sortOrder))
      .set('filters', query)
      .set('type', type || '')
      .set('roleId', roleId || '')
      .set('istopup', istopup || '')
      .set('istransfer', istransfer || '')
      .set('mode', mode || '');

    const url = environment.APIURL + CREATE_APPLICATION;

    const headers: any = {};
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);

    return this.http.get(url, { headers, params });
  }

  downloadPDF(body: any) {
    //const url = environment.APIURL + DOWNLOAD_PDF + `/${body.applicationUuid}`;
    const url = environment.APIURL + DOWNLOAD_PDF_DIGIO;

    let req = {} as any;
    req.formId = body.formId.toString();
    req.InvestmentId = body.InvestmentId.toString();
    req.GroupId = body.GroupId.toString();
    req.Type = body.Type.toString();

    let headers = {} as any;
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    return this.http.post(url, req, { headers });
  }

  downloadNonIndividualPDF(body: any) {
    //const url = environment.APIURL + DOWNLOAD_NOnIndividual_PDF + `/${body.applicationUuid}`;
    const url = environment.APIURL + DOWNLOAD_PDF_DIGIO;

    let req = {} as any;
    req.formId = body.formId.toString();
    req.InvestmentId = body.InvestmentId.toString();
    req.GroupId = body.GroupId.toString();
    req.Type = body.Type.toString();

    let headers = {} as any;
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    return this.http.post(url, req, { headers });
  }

  downloadPDFAfterEsign(body: any) {
    const url = environment.APIURL + DOWNLOAD_PDF_AFTER_ESIGN + `/${body.applicationUuid}` + `/${body.type}`;
    let headers = {} as any;
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    return this.http.get(url, { headers });
  }

  downloadMultipleAttachment(body: any) {
    //const url = environment.APIURL + DOWNLOAD_PDF + `/${body.applicationUuid}`;
    const url = environment.APIURL + DOWNLOAD_MULTIPLEFILES;

    let req = {} as any;
    req.formId = body.formId.toString();
    req.InvestmentId = body.InvestmentId.toString();
    req.GroupId = body.GroupId.toString();
    req.Type = body.Type.toString();

    let headers = {} as any;
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    return this.http.post(url, req, { headers });
  }

  downloadPhysicalMultipleFiles(body: any) {

    const url = environment.APIURL + DOWNLOAD_PHYSICAL_SIGN_MULTIPLEFILES;

    let req = {} as any;

    req.InvestmentId = body.InvestmentId;
    req.DocType = body.DocType;
    req.UserId = body.UserId;

    let headers = {} as any;
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    return this.http.post(url, req, { headers });
  }

  // recheck application by client 
  recheckApplication(body: any) {
    const url = environment.APIURL + APPLICATION_RECHECK;
    let req = {} as any;
    req.UserId = body.UserId;
    req.InvestmentId = body.InvestmentId;
    req.Remark = body.Remark;
    let headers = {};
    headers[AUTHORIZATION] = BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    return this.http.post(url, req, { headers });

  }
  // delete application by client
  deleteApplication(body: any) {
    const url = environment.APIURL + DELETE_APPLICATION;
    let req = {} as any;
    req.UserId = body.UserId;
    req.InvestmentId = body.InvestmentId;
    req.Remark = body.Remark;
    let headers = {};
    headers[AUTHORIZATION] = BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    return this.http.post(url, req, { headers });

  }
  getTransferApplications(
    searchText: string,
    pageSize: number,
    pageIndex: number
  ) {
    const body = {
      searchValue: searchText,
      pageSize: pageSize,
      pageIndex: pageIndex
    };

    const url = environment.APIURL + GET_TRANSFER_APPLICATIONS;

    let headers = {} as any;
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    return this.http.post(url, body, { headers });
  }

  uploadDIS(formId: string, tranferID: string) {
    const url = environment.APIURL + UPLOAD_DIS_SLIP;
    let headers = {} as any;
    headers[AUTHORIZATION] = BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    const formData = new FormData();
    formData.append('formId', formId);
    formData.append("tranferID", tranferID)
    return this.http.post(url, formData, { headers });
  }

  DownloadDIS(formId: string, transferId: string) {
    const url = environment.APIURL + DOWNLOAD_DIS_SLIP;
    const headers = {
      [AUTHORIZATION]: BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN)
    };
    const params = new HttpParams()
      .set('formId', formId)
      .set('transferId', transferId);

    return this.http.get<any>(url, { headers, params });
  }

  ApproveDIS(payload: any) {
    const url = environment.APIURL + APPROVE_DIS_SLIP;
    const headers = {
      [AUTHORIZATION]: BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN)
    };
    return this.http.post(url, payload, { headers });
  }

  RejectDIS(payload: any) {
    const url = environment.APIURL + APPROVE_DIS_SLIP;
    const headers = {
      [AUTHORIZATION]: BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN)
    };
    return this.http.post(url, payload, { headers });
  }

  getPledgeUnppledgeApplications(body: any) {
    const url = environment.APIURL + GET_PLEDGE_UNPLEDGE_APPLICATIONS;
    // const params = { search: filterValue };
    let req = {} as any;
    req.searchItem = body.searchItem;
    req.pageNumber = body.pageNumber,
      req.pageSize = body.pageSize
    let headers = {} as any;
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    return this.http.post(url, req, { headers });
  }

  getEsignDetails(investmentFormDocId: any) {
    const url = `${environment.APIURL}/api/v1/application/getEsignstatus?InvestmentFormDocumentID=${investmentFormDocId}`

    const headers = {
      [AUTHORIZATION]: BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN)
    };

    return this.http.get<any[]>(url, { headers });
  }

  getPledgeRequest(body) {
    const url = environment.APIURL + GET_ALL_PLEDGE_REQUEST;
    let headers = {} as any;
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);
    return this.http.post(url, body, { headers });
  }

  getPledgeMIS() {
    const url = environment.APIURL + GET_PLEDGE_MIS;
    let headers = {} as any;
    headers[AUTHORIZATION] =
      BEARER_TOKEN_PREFIX + localStorage.getItem(ACCESS_TOKEN);

    const body = {
      From: '2025-03-20',
      To: '2025-01-20',
      type: 'pledge'
    }
    return this.http.post(url, body, { headers });
  }
}
